export var TEXT_TYPE;
(function (TEXT_TYPE) {
  TEXT_TYPE["BODY_PARA_SM"] = "body-para-sm";
  TEXT_TYPE["BODY_PARA_MD"] = "body-para-md";
  TEXT_TYPE["BODY_PARA_XS"] = "body-para-xs";
  TEXT_TYPE["BODY_PARA_SM_BOLD"] = "body-para-sm-bold";
  TEXT_TYPE["BODY_PARA_LG_BOLD"] = "body-para-lg-bold";
  TEXT_TYPE["BODY_PARA_XL_BOLD"] = "body-para-xl-bold";
  TEXT_TYPE["BODY_PARA_MD_BOLD"] = "body-para-md-bold";
  TEXT_TYPE["TITLE_SINGLE_LINE_LG"] = "title-single-line-lg";
  TEXT_TYPE["TITLE_SINGLE_LINE_XL"] = "title-single-line-xl";
  TEXT_TYPE["BODY_SINGLE_LINE_XS"] = "body-single-line-xs";
  TEXT_TYPE["BODY_SINGLE_LINE_SM"] = "body-single-line-sm";
  TEXT_TYPE["MD"] = "md";
  TEXT_TYPE["LG"] = "lg";
})(TEXT_TYPE || (TEXT_TYPE = {}));